import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class UsuarioService {
    private urlModulo = `${environment.urlAPI}/usuario`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista de usuários do sistema (não traz fornecedores e auditores)
     */
    public getListaUsuarios(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.usuarios);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera usuário pelo ID
     */
    public getUsuarioById(uid: number): Promise<any> {
        const params = new HttpParams().set('uid', uid.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byid`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.usuario);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera usuário pelo CPF
     */
    public getUsuarioByCPF(cpf: string): Promise<any> {
        const params = new HttpParams().set('cpf', cpf);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-bycpf`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.usuario);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Salva dados do usuário
     */
    public gravaUsuario(user: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvar`, user)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza perfil do usuário
     */
    public gravaUsuarioPerfil(user: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-perfil`, user)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Ativa/Inativa um usuário
     */
    public inativarUsuario(codigo: number, inativo: boolean): Promise<any> {
        const payload = { uid: codigo, inativo: inativo };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-inativar`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Altera senha do usuário
     */
    public alterarSenha(novaSenha: string, cpf_cnpj: string): Promise<any> {
        const payload = { novaSenha, cpf_cnpj };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-novaSenha`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Verifica se CNPJ/CPF já está em uso
     */
    public verificaCNPJ_CPFUsuario(cnpj: string): Promise<any> {
        const params = new HttpParams().set('cnpj', cnpj);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-verificacnpj_cpf`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera sistemas de gestão do usuário
     */
    public getSistemaGestaoUsuario(listaCodSistemaGestao: any): Promise<any> {
        const params = new HttpParams().set('listaCodSistemaGestao', listaCodSistemaGestao);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-sistemaGestaoUsuario`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.listaSG);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera email do usuário
     */
    public getUsuarioEmail(uid: any): Promise<any> {
        const params = new HttpParams().set('uid', uid);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-usuarioemail`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/usuario.service.ts